// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
'use client'

import { hermesLogger } from '@core/observability'

export const isMobile = () => {
  if (typeof navigator === 'undefined') {
    return false
  }

  let detection = false

  if (typeof navigator !== 'undefined' && navigator.userAgentData) {
    detection = navigator.userAgentData.mobile
  }

  if (!detection) {
    if (
      navigator.userAgent.match(/Android/i) ||
      navigator.userAgent.match(/webOS/i) ||
      navigator.userAgent.match(/iPhone/i) ||
      navigator.userAgent.match(/iPad/i) ||
      navigator.userAgent.match(/iPod/i) ||
      navigator.userAgent.match(/BlackBerry/i) ||
      navigator.userAgent.match(/Windows Phone/i)
    ) {
      detection = true
    }
  }

  if (!detection) {
    if (navigator.userAgentData) {
      if (
        !navigator.userAgentData.platform.match(/win/i) &&
        !navigator.userAgentData.platform.match(/mac/i) &&
        !navigator.userAgentData.platform.match(/linux/i)
      ) {
        hermesLogger.warn('[Device identification] Maybe not a desktop', {
          device: {
            userAgentData: navigator.userAgentData,
            userAgent: navigator.userAgent,
          },
        })
      }
    } else {
      hermesLogger.warn(
        '[Device identification] Maybe a iOS as desktop using safari',
        {
          device: {
            userAgentData: navigator.userAgentData,
            userAgent: navigator.userAgent,
          },
        }
      )
    }
  }

  return detection
}
